export default __webpack_public_path__ + "static/media/accelerometer.687342d5.png";